import React, { Component } from "react";

class Kurser extends Component {
  render() {
    return (
      <center>
        <div className="info" style={{ textAlign: "left" }}>
          <center>
            <h1>
              Kurser på folkmusikkaféet
              <br />
              Hösten 2026
            </h1>
          </center>
          <br />
          <center>
            <i>
              Kursdeltagare får 50 % rabatt på konsert- och danskvällar under
              kursen (detta kan ej kombineras med andra rabatter).
            </i>
          </center>
          <br />

          <center>
            <h3>Spelmanslaget</h3>
            <img
              className="kursbild-mindre fade-in-fast"
              style={{ paddingRight: "40px" }}
              src="img/arkiv/jon_olov.jpg"
              alt="Jon-Olov Woxlin"
            />
            <img
              className="kursbild-mindre fade-in-fast"
              src="img/arkiv/dan_palmqvist_small.jpg"
              alt="Dan Palmqvist"
            />
          </center>
          <center>
            <div className="kompakt">
              Kursen hålls fredagar kl 17:30 - 19:15 med start 18 september och
              omfattar hela hösten och alla med akustiska instrument är
              välkomna. Vi ser gärna att du har något eller några års erfarenhet
              på ditt instrument. Som kompmusiker ser vi helst att du är
              relativt självständig och kan lite grunder i folkmusik.
              <br />
              <br />
              Kursinstruktör: Jon-Olov Woxlin och Dan Palmqvist.
              <br />
              <br />
              Kostnad: 600 kr (ung &amp; stud 350 kr) betalas in på pg 107741-1
              eller Swish 1236085450. Ange namn + ”spelmanslaget”.
              <br />
              <br />
              <small>
                Information: Dan Palmqvist,{" "}
                <a href="mailto:dan.palmqst@gmail.com">dan.palmqst@gmail.com</a>
              </small>
            </div>
          </center>
          <br />

          <center>
            <h3>Nybörjarkurs i dans till folkmusik</h3>
          </center>
          <br />
          <center>
            <img
              style={{ width: "40%", borderRadius: "10px" }}
              src="img/program/ht2026/danskurs_nyborjare.jpg"
              alt="Nybörjarkurs i dans"
            />
          </center>
          <br />
          <center>
            <small>
              Sex fredagskvällar med start 18/9 och avslutning 23/10.
            </small>
            <br />
            <br />
            <div className="kompakt">
              Kursen ger grunderna i de vanligast förekommande danserna på
              Folkmusikkaféet och andra liknande folkmusik- och dansställen i
              Sverige. Vi tar i första hand upp pardanserna schottis, polska,
              slängpolska och vals samt gruppdansen engelska - men även andra
              inslag kan förekomma.
              <br />
              <br />
              Första tillfället 18/9 är gratis och kräver ingen förbokning. Du
              kan alltså komma första gången och prova på, och därefter bestämma
              om du vill fortsätta kursen eller inte.
              <br />
              <br />
              Kursinstruktörer: Mats Nilsson och Ingegerd Sigfridsson.
              <br />
              Spelman: Staffan Folestad
              <br />
              <br />
              Tider: Fredagskvällar 18:00 - 19:30.
              <br />
              Kursavgift: 500 kr (ung &amp; stud 250 kr).
              <br />
              <br />
              Kursen arrangeras i samarbete med Bilda. Anmälan görs via{" "}
              <a
                href="https://www.bilda.nu/arr/1301770/nyborjarkurs-i-dans-till-folkmusik-932455/"
                target="_blank"
                rel="noopener noreferrer"
              >
               Denna länk 
              </a>
              .
              <br />
              <br />
              Frågor till Mats Nilsson, tel. 070-5577916 eller{" "}
              <a href="mailto:kurser@folkmusikkafeet.net">
                kurser@folkmusikkafeet.net
              </a>
            </div>
          </center>
          <br />

          <center>
            <h3>Fortsättningskurs i dans till folkmusik</h3>
          </center>
          <br />
          <center>
            <img
              style={{ width: "40%", borderRadius: "10px" }}
              src="img/program/ht2026/danskurs_fortsattning.jpg"
              alt="Fortsättningskurs i dans"
            />
          </center>
          <br />
          <center>
            <small>
              Sex fredagskvällar med start 30/10 och avslutning 4/12.
            </small>
            <br />
            <br />
            <div className="kompakt">
              Fortsättningskursen är till för er som gått nybörjarkursen eller
              har motsvarande förkunskaper från tidigare, och vill lära er mer.
              Främst tar vi upp några olika polskor och kanske någon
              schottisvariant. Exempel på kursdanser kan vara Finnskogspols,
              Åtabak samt polskor från Malung och Orsa.
              <br />
              <br />
              Kursinstruktörer: Ingela och Håkan Lindberg.
              <br />
              Spelman: Björn Johnsson
              <br />
              <br />
              Tider: Fredagskvällar 18:00 - 19:30.
              <br />
              Kursavgift: 600 kr (ung &amp; stud 300 kr). Den som har gått
              nybörjarkursen får rabatt på fortsättningskursen under samma
              termin, priset blir då 500 kr (ung &amp; stud 250 kr).
              <br />
              <br />
              Kursen arrangeras i samarbete med Bilda. Anmälan görs via{" "}
              <a
                href="https://www.bilda.nu/arr/1301772/fortsattningskurs-i-dans-till-folkmusik-932456/"
                target="_blank"
                rel="noopener noreferrer"
              >
               Denna länk 
              </a>
              .
              <br />
              <br />
              Frågor till Håkan Lindberg, tel. 0767-133250 eller{" "}
              <a href="mailto:kurser@folkmusikkafeet.net">
                kurser@folkmusikkafeet.net
              </a>
            </div>
          </center>
          <br />

          <center>
            <h3>Låtkurs - låtar från Røros</h3>
          </center>
          <center>
            <img
              style={{ width: "40%", borderRadius: "10px" }}
              src="img/program/ht2026/latkurs_roros_tron_westberg.jpg"
              alt="Tron Steffen Westberg"
            />
          </center>
          <br />
          <center>
            <div className="kompakt">
              Tron Steffen Westberg fra Brekken i Røros har lang erfaring som
              låtkursholder i inn- og utland. Han tar med seg et utvalg
              rørospolser fra Røros og Brekken, noen av den mer enkle, lettlærte
              sorten og andre mer finurlige og skakke ‘gammelpolser’. Kurset vil
              foregå via muntlig overføring (gehør, uten noter, men det kan
              medbringes noter på noen av polsene). Som kursdeltagare behöver du
              behärska ditt instrument någorlunda.
              <br />
              <br />
              Kursledare: Tron Steffen Westberg
              <br />
              Tid: Lördag 31/10 kl 10:00 - 16:00
              <br />
              Plats: Gräfsnäsgårdens annex
              <br />
              Kursavgift: 500 kr (ung &amp; stud 300 kr)
              <br />
              <br />
              Kursen arrangeras i samarbete med Bilda. Kursanmälan görs senast
              16/10. Länk till kursanmälan kommer snart att publiceras här.
              <br />
              <br />
              Frågor:{" "}
              <a href="mailto:kurser@folkmusikkafeet.net">
                kurser@folkmusikkafeet.net
              </a>
              , tel. 0703327781 (Lars-Gunnar Franzén)
            </div>
          </center>
          <br />

          <center>
            <h3>Danskurs - rørospols</h3>
          </center>
          <center>
            <img
              style={{ width: "40%", borderRadius: "10px" }}
              src="img/program/ht2026/danskurs_rorospols.jpg"
              alt="Danskurs i rørospols"
            />
          </center>
          <br />
          <center>
            <div className="kompakt">
              Bergitte Kjosvatn og Per Ivar Tamnes holder dansekurset i
              rørospols. Begge er erfarne polsdansere og instruktører som også
              har utdanning i tradisjonskunnskap og norsk folkedans, fra
              Universitetet i Sørøst-Norge og NTNU - Norges Teknisk
              Vitenskapelige Universitet. Kurset tar for seg rørospolsen fra
              første grunntrinn og videre inn i polsens variasjoner og
              muligheter for personlig stil i dansen.
              <br />
              <br />
              Kursledare: Bergitte Kjosvatn og Per Ivar Tamnes
              <br />
              Spelman: Ole Erik Feragen
              <br />
              Tid: Lördag 31/10 kl 10:00 - 16:00
              <br />
              Plats: Gräfsnäsgården
              <br />
              Kursavgift: 500 kr (ung &amp; stud 300 kr)
              <br />
              <br />
              Kursen arrangeras i samarbete med Bilda. Kursanmälan görs senast
              16/10. Länk till kursanmälan kommer snart att publiceras här.
              <br />
              <br />
              Frågor:{" "}
              <a href="mailto:kurser@folkmusikkafeet.net">
                kurser@folkmusikkafeet.net
              </a>
            </div>
          </center>
          <br />

          <center>
            <h3>Tillsammansgruppen</h3>
            <img
              className="kursbild fade-in-fast"
              src="img/tillsammansgruppen.jpg"
              alt="Tillsammansgruppen"
            />
          </center>
          <center>
            <div className="kompakt">
              Genom alla tider har vi lekt på fest och till vardags, barn som
              vuxen. Tillsammansgruppen ger dig möjlighet att ta del av denna
              roliga tradition.
              <br />
              Stora som små är varmt välkomna att hänga med i vindlande
              långdanser och visor.
              <br />
              Det är motion för både kropp som knopp!
              <br />
              <br />
              Tider: 18:00 - 19:30 med tid för fika.
              <br />
              Datum: 18/9, 16/10 och 20/11
              <br />
              Instruktörer: Gunnel Sjögren och Gunilla Sellersjö
              <br />
              <br />
              Kostnad: Gratis för barn i sällskap med någon vuxen.
            </div>
          </center>
          <br />
          <br />

        </div>
      </center>
    );
  }
}

export default Kurser;
